import { createV3Queries } from "@query/utils/createV3Queries";
import { customFieldsApi } from "@api";

export const queriesCustomFields = createV3Queries(
  "customFieldsApi",
  customFieldsApi
);
